const ALLOWED_EXTENSION_MAPPINGS = [
    {
        extension: '.pdf',
        fontIcon: 'fa-file-pdf'
    },
    {
        extension: '.tiff',
        fontIcon: 'fa-file-image'
    },
    {
        extension: '.png',
        fontIcon: 'fa-file-image'
    },
    {
        extension: '.jpg',
        fontIcon: 'fa-file-image'
    },
    {
        extension: '.jpeg',
        fontIcon: 'fa-file-image'
    },
    {
        extension: '.gif',
        fontIcon: 'fa-file-image'
    },
    {
        extension: '.rtf',
        fontIcon: 'fa-file-alt'
    },
    {
        extension: '.doc',
        fontIcon: 'fa-file-word'
    },
    {
        extension: '.docx',
        fontIcon: 'fa-file-word'
    },
    {
        extension: '.xls',
        fontIcon: 'fa-file-excel'
    },
    {
        extension: '.xlsx',
        fontIcon: 'fa-file-excel'
    },
    {
        extension: '.zip',
        fontIcon: 'fa-file-archive'
    },
    {
        extension: '.msg',
        fontIcon: 'fa-envelope'
    },
    {
        extension: '.txt',
        fontIcon: 'fa-file-alt'
    },
    {
        extension: '.xml',
        fontIcon: 'fa-file-xml'
    }
];

export const DIDO_DOCUMENTEN_CONTROL_CONSTANTS = {
    STORAGE_KEY_PREFIX: 'domain.dido.controls.documenten',
    // 70 Mb limiet
    DEFAULT_MAX_FILE_SIZE: 78643200,
    /** Allowed extensions mappings*/
    ALLOWED_EXTENSION_MAPPINGS,
    ALLOWED_EXTENSIONS_INTERN: ALLOWED_EXTENSION_MAPPINGS.map((mapping) => mapping.extension),
    ALLOWED_EXTENIONS_EXTERN: ALLOWED_EXTENSION_MAPPINGS.map((mapping) => mapping.extension).filter((ext) => ext != '.msg')
} as const;
